import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import Button from '../buttons/Button';
import useStyles from './ConfirmationModal.styles';
import Modal from './Modal';
import InputGroup from '../fields/InputGroup';

const ConfirmationModal = ({ closeModal, confirmButtonLabel, onConfirmClick, onCancelClick, children }) => {
  const classes = useStyles();

  const handleConfirmClick = useCallback(() => {
    onConfirmClick();
    closeModal();
  }, [closeModal, onConfirmClick]);

  const handleCancelClick = useCallback(() => {
    if (onCancelClick) onCancelClick();
    closeModal();
  }, [closeModal, onCancelClick]);

  return (
    <Modal>
      <div className={classes.content}>
        {children}
        <InputGroup className={classes.buttonGroup}>
          <Button id="cancelButton" className={classes.cancelButton} onClick={handleCancelClick}>
            {i18n.t('common.button.cancel')}
          </Button>
          <Button id="confirmButton" className={classes.button} primary onClick={handleConfirmClick}>
            {confirmButtonLabel}
          </Button>
        </InputGroup>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmButtonLabel: PropTypes.string.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func,
  children: PropTypes.node,
};

ConfirmationModal.defaultProps = {
  children: undefined,
  onCancelClick: undefined,
};

export default ConfirmationModal;
